import { render } from "./ThemeIcon.vue?vue&type=template&id=467e9bbe"
import script from "./ThemeIcon.vue?vue&type=script&lang=js"
export * from "./ThemeIcon.vue?vue&type=script&lang=js"

import "./ThemeIcon.vue?vue&type=style&index=0&id=467e9bbe&lang=scss"

import exportComponent from "/app/tmp/blackhall/V3/v2026.32.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__